// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"j7-z"};